import * as React from "react";
const RandomIdContext = /*#__PURE__*/React.createContext(() => {
  throw new Error("Orbit RandomIdProvider: useId is undefined; please provide React.useId or `react-uid`'s useUID.");
});
const RandomIdProvider = ({
  children,
  useId
}) => {
  return /*#__PURE__*/React.createElement(RandomIdContext.Provider, {
    value: useId
  }, children);
};
export const useRandomId = () => React.useContext(RandomIdContext);
export default RandomIdProvider;